const base = require('./base')
const wechatAPI = {
  login:base.base.PHPPath+'itofficialaccount/login/login'
}
module.exports = {
    wechatAPI:wechatAPI
}


// WEBPACK FOOTER //
// ./src/api/weChatOfficialAcount.js